import { useEffect } from 'react'
import type { IResponseEventMessagePopper } from 'entities/Message'
import { WebsocketEvent } from 'entities/WebSocket/store'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventMessagePopperLog = () => {
  const { websocket, dataLogStore } = useEntitiesContext()
  const handle = (data: IResponseEventMessagePopper) => {
    const { user_id, inbox_id } = data

    dataLogStore.setItem({
      logLevel: 'info',
      message: 'EventMessagePopper',
      details: {
        inboxId: inbox_id,
        userId: user_id,
      },
    })
  }

  useEffect(() => websocket.on(WebsocketEvent.MessagePopper, handle), [])
}
